import * as React from 'react';
import { useStopEventBackgroundPropagation } from 'mini-hooks/lib/useStopEventBackgroundPropagation';

const styles = require('./Overlay.scss');
const classNames = require('classnames/bind').bind(styles);

export interface OverlayProps {
    onClick?: (ev?: React.MouseEvent<any>) => void;
    className?: string;
}

const Overlay: React.FC<OverlayProps> = props => {
    const overlayRef = useStopEventBackgroundPropagation();
    const { onClick, className } = props;
    const effectiveOnClick = (ev?: React.MouseEvent<any>) => {
        onClick?.(ev);
        ev?.stopPropagation();
    };

    return (
        <div
            className={classNames(styles.overlay, className)}
            role="none"
            ref={overlayRef}
            onClick={effectiveOnClick}
            aria-hidden
        />
    );
};

export default Overlay;
